module.exports = __webpack_public_path__ + "img/stamps2.b68c1fbc.jpg";